import React from 'react'

const hanoiFood = {
    id: 'hanoi-street-food',
    type: 'post',
    countryId: 'seAsia',
    title: "Eating Our Way Through Hanoi's Street Food",
    longDate: 'October 17, 2018',
    month: 'Oct',
    date: '17',
    coverImage: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/HanoiStreetFood/Cover.jpg',
    content: [
        {
            text: (
                <div>We are by no means experts on the street food of Hanoi and what the 'best' dishes and places to get them are, but in our two weeks in Hanoi, we ate as much as we could stuff ourselves with.</div>
            )
        },
        {
            text: (
                <div>On our third day in the city, after having eaten mostly pho because we didn't know what anything else was, we went on a street food tour through Airbnb Experiences. The other four people on the tour were only doing the food part, but we had a two-for-one with a biking tour of the city that nearly killed us. The driving style here is insane! By the time we started the street food tour, we were hungry enough to finish off every one of the 7 or 8 dishes our guide Oliver procured.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/HanoiStreetFood/Tour.jpg',
        },
        {
            text: (
                <div>Now, we just have a look at what other people have on their plates and hold up two fingers to order. We also met a Brit, Sergei, who is living and working remotely here and shared his Google Map file of his favorite food spots. We proceeded to check one off the list every day.</div>
            )
        },
        {
            text: (
                <div>So: pictures and stories of the food we've encountered on the streets of Hanoi.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/HanoiStreetFood/Peter3.jpg',
            detailText: 'We are giants here! Every street food and bia hoi place has tiny tables and red or blue plastic chairs on the sidewalk to sit on.'
        },
        {
            header: 'Pho'
        },
        {
            text: (
                <div>Pho (Phở) is the classic Vietnamese noodle dish. A majority of the street food vendors we walked past offered pho. The most common kind here is Phở Bò (beef pho), which is a relic from the French colonial era – the Vietnamese traditionally eat more pork and chicken. The broth is fairly light and spiceless, which is typical of northern Vietnam, and the dish consists of thin strips of beef, flat rice noodles, and white and green onions. The tables have optional hot sauce, lime, and what looked like pickled garlic to mix in.</div>
            )
        },
        {
            text: (
                <div>I got pretty fond of "breakfast" pho at a spot around the corner from us in Ba Dinh (<a href="https://www.google.com/maps/place/Qu%C3%A1n+Ph%E1%BB%9F+B%C3%B2+G%E1%BB%91c+G%E1%BA%A1o/@21.0366914,105.8289792,17.19z/data=!4m5!3m4!1s0x0:0x8722f7097cf8255d!8m2!3d21.0377766!4d105.8297398">Quán Phở Bò Gốc Gạo</a>), and probably ate there for half of my breakfasts. It's across the street from a small, pretty temple called Đình Ngọc Hà, and on a few occasions we walked through the temple, past the small lake, and into the tiny and crazy busy alleyways to buy eggs, fruit, and bread from people selling out of plastic bowls in doorways.</div>
            )
        },
        {
            text: (
                <div>Peter's favorite pho came from a spot on Sergei's list, <a href="https://www.google.com/maps/place/Pho+10/@21.0304975,105.848242,19z/data=!3m1!4b1!4m5!3m4!1s0x3135ab9588b10501:0xf8a3cc53d3aad1eb!8m2!3d21.0304962!4d105.8487892">Phở 10</a>. Phở 10 was the closest to a real restaurant we got – still with windowless walls opened onto the street, one cooktop with one dish served, and food coming out less than a minute after you order, but with the crucial difference that there were full-human-size tables and chairs! Since so many spots only serve one thing, they're often known by a number like "Pho 10" or "Banh Cuon 33."</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/HanoiStreetFood/Pho.jpg',
        },
        {
            header: 'Banh Cuon'
        },
        {
            text: (
                <div>Banh Cuon (bánh cuốn) are steamed rice rolls. The dish is mostly the dough of the roll, with dried-ish mushrooms or sometimes meat sprinkled in the middle and served with fresh herbs and a dipping sauce. They're made with a really cool, <a href="https://www.youtube.com/watch?v=6gaKvWmSyrQ">crepe-like process</a>.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/HanoiStreetFood/BanhCuon.jpg',
        },
        {
            header: 'Bun Cha'
        },
        {
            text: (
                <div>As nearly anyone here will tell you, bun cha (bún chả) is what Obama ate when he came to Hanoi and filmed an episode on Anthony Bourdain's show. The restaurant has enshrined the table and chairs in plastic, and they're sitting in the corner. We ate in the downstairs part of that now-famous spot, and can confirm that bun cha is amazing.</div>
            )
        },
        {
            text: (
                <div>Peter's favorite dish in Hanoi was the bun cha at <a href="https://www.google.com/maps/place/B%C3%BAn+Ch%E1%BA%A3+Tuy%E1%BA%BFt/@21.0412337,105.8450112,17z/data=!3m1!4b1!4m5!3m4!1s0x3135abb9f027dc77:0x2f4b475fb6ee2889!8m2!3d21.0412287!4d105.8471999">Bun Cha 34</a>, a spot on Sergei's map. The broth is served slightly warm instead of steaming and is fairly vinegary and a bit sweet. Small pork patties and fatty bits of pork are in the broth, and the vermicelli rice noodles and massive bowl of fresh herbs and lettuces are on the side for you to dip in.</div>
            )
        },
        {
            text: (
                <div>Bun cha is often served with nem rán, fried spring rolls, just in case you want to truly stuff yourself (we always did.)</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/HanoiStreetFood/BunCha.jpg',
        },
        {
            header: 'Pho Xao'
        },
        {
            text: (
                <div>If we were ever both hungry and didn't want to walk far for food, there was a spot in our alley off Ngọc Hà that served a rotating menu of items, and usually had Pho Xao. Unlike the other pho, this one skips the broth and fries the pho noodles into a messy pancake shape, then tops them with sautéed veggies and meat. It's served with pickled cucumbers and optional hot sauce. Peter loved this one and got it several times when he needed extra food.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/HanoiStreetFood/PhoXao.jpg',
        },
        {
            header: 'Sweet and Savory Donuts'
        },
        {
            text: (
                <div>We never saw these outside of a spot Oliver took us to on the street food tour, but that just meant we went back to the same spot to get our fried donut fix. 'Donut' is a bit of a misnomer; they don't resemble American donuts at all. It's more like fried balls of dough stuffed with either veggies and meat or sweet bean paste. I have been obsessed with sweet bean paste since Japan and adored these, but most Americans – Peter included – don't like them as much.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/HanoiStreetFood/Donuts.jpg',
        },
        {
            header: 'Xoi Ga / Xoi Xeo'
        },
        {
            text: (
                <div>You can find sticky rice in various formats across Hanoi. We had it twice - once topped with chicken (xôi gà) and once wrapped in banana leaves and stuffed with bits of pork and what we think was either mashed corn or beans. Not much to say about either one, except that it's a basic we encountered everywhere.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/HanoiStreetFood/XoiGa.jpg',
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/HanoiStreetFood/BananaRice.jpg',
        },
        {
            header: 'Banh Mi'
        },
        {
            text: (
                <div>Of course, we'd be remiss not to mention one of Vietnam's major exports to America, the banh mi sandwich. But to be honest, (*in a whisper*) they're better in San Francisco. The banh mi is very much a product of French colonialism: a french baguette stuffed with a generous portion of paté, sliced pork, jalapeños, carrots, cucumber, and cilantro, topped with sauce. But while the banh mis from Dinosaur's in San Francisco are full of fresh flavor and pickled crunch of the vegetables, the ones here are much lighter on the fresh factor and heavy on the paté and sauce.</div>
            )
        },
        {
            text: (
                <div>The best banh mis we found were at Banh Mi 25 in the north end of the Old Quarter (again, thank you Sergei!) Peter's favorite food in the world might be sandwiches, so we went no less than four times and used them as fuel for long bus rides out of Hanoi. But we also encountered some pretty awful ones, pressed like a Quizno's hot sandwich and devoid of any freshness – and one with a <i>hot dog</i> in it.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/HanoiStreetFood/BanhMi.jpg',
        },
        {
            header: 'Egg Coffee'
        },
        {
            text: (
                <div>Egg coffee (cà phê trúng) is not really street food, but it deserves a mention anyway because it's unique to Hanoi and served in cafés across the city. The unarguably best spots to get it are Cafe Dinh and Cafe Giang. Cafe Giang is the original, if you're going for maximum foodie points, but Dinh is owned by a relative. We tried it at Cafe Dinh and at The Note, a cute but possibly overly-bubbly spot covered in handwritten notes on rainbow colored paper.</div>
            )
        },
        {
            text: (
                <div>Someone told us to avoid the egg coffee actually served on the streets since there's raw egg in it. Come to think of it, raw anything on the street is a bit of a gamble with your stomach. Peter even avoided the herbs that come with bun cha but I have been eating all of them... here's to hoping I don't get sick.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/HanoiStreetFood/EggCoffee1.jpg',
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/HanoiStreetFood/EggCoffee2.jpg',
        },
        {
            header: 'Bia Hoi'
        },
        {
            text: (
                <div>Beer isn't a food (unless you're on that <a href="https://lordsofthedrinks.com/2016/02/11/the-all-beer-diet-german-monks-created-for-the-46-days-of-lent-fast-before-easter/">monk diet</a>) but we have to include bia hoi as well. It's beer that's brewed daily and served from kegs into plastic cups, and sold for ridiculous low prices - usually about 25 cents. To me it tastes like Natty Light, but to each their own! I didn't get any photos of this because we were too busy drinking it, so I'll just let you all imagine.</div>
            )
        },
    ]
}


export default hanoiFood


// WEBPACK FOOTER //
// ./src/Posts/Content/HanoiFood.js